


























































































































import Vue, { PropType } from 'vue';
import TopBar from '@/components/widgets/TopBar.vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import Button from '@/components/form/Button.vue';
import filterParams from '@/components/table/utils/filterParameters';
import FieldInput from '@/components/form/FieldInput.vue';
import SelectChipsFromRightSlide from '@/components/chips/SelectChipsFromRightSlide.vue';
import { IChipsData, DropdownList } from '@/types';
import { IStateInventory } from '@/types/publisher/inventory';
import InventoryPlacement from '@/components/publisher/InventoryPlacement.vue';
import FieldMultipleSelect from '@/components/form/FieldMultipleSelect.vue';
import Preloader from '@/components/preloader/Preloader.vue';

export default Vue.extend({
  name: 'InventoryForm',
  components: {
    Preloader,
    FieldMultipleSelect,
    InventoryPlacement,
    TopBar,
    WidgetWrapper,
    Button,
    FieldInput,
    SelectChipsFromRightSlide,
  },
  props: {
    langs: {
      type: Array as PropType<Array<DropdownList>>,
    },
    category: {
      type: Array as PropType<Array<DropdownList>>,
    },
    loadData: {
      type: Boolean,
      default: false,
    },
  },
  
  computed: {
    inventory(): IStateInventory {
      return this.$store.getters['publisher/getInventory'];
    },
    routerBack() {
      return filterParams.getUrlBack() || '';
    },
    title(): string {
      return this.inventory?.name || '#1';
    },
    readyToSave(): boolean {
      return this.$store.getters.hasValidationErrors;
    },
    isSavingForm(): boolean {
      return this.$store.getters['publisher/getIsSavingForm'];
    },
  },
  methods: {
    submitForm() {
      this.$emit('submit');
    },
    closeForm() {
      this.$router.push(this.routerBack);
    },
    updateCategories(categories: Array<IChipsData>): void {
      this.updateInvetory(
        'categories',
        categories.map((c) => c)
      );
    },
    updateLanguages(language: Array<string> ): void {
      this.updateInvetory(
        'languages',
        language.map((l) => l)
      );
    },
    removeLangTargets(index) {
      const languages = this.inventory.languages;
      if (languages.length) {
        languages.splice(index, 1);
      }
      this.updateInvetory('languages', languages);
    },
    getNameLanguage(value) {
      const lang = this.langs.find((item) => item.value === value);
      if (lang) {
        return lang.label;
      }
    },
    updateInvetory(propName: string, value: any): void {
      this.$store.dispatch('publisher/updateInventoryData', {
        propName,
        value,
      });
    },
  },
});
